import { Button, Col, Form, InputNumber, Row } from 'antd';
import React from 'react'
import "../Detail.css"
function FormCreateRevenueResponsive({
    formExpectedRevenue,
    onFinishExpectedRevenue,
    validateMessages,
    loadingBtnDtdk,
    closeCreateRevenue,
    valuesDetail
}) {
    return (
        <>
            <div className="bg-dtdk">
                <div style={{ marginTop: "20px" }}>
                    <Row style={{ marginBottom: 8 }}>
                        <Col className="title-dtdk" span={22} offset={1}>
                            Doanh thu dự kiến {valuesDetail.date.$y}
                        </Col>
                    </Row>
                    <Form
                        form={formExpectedRevenue}
                        layout="vertical"
                        autoComplete="off"
                        onFinish={onFinishExpectedRevenue}
                        // onFinishFailed={onFinishFailed}
                        validateMessages={validateMessages}
                        initialValues={{
                            remember: true,
                        }}
                        className="custom-form"
                        key="formImport"
                    >
                        <div style={{ marginTop: 20 }}>
                            <Row>
                                <Col span={6} offset={1}>
                                    <Form.Item
                                        name="thang_1"
                                        label=<span className="custom-field-revenue">
                                            Tháng 1
                                        </span>
                                        key="thang_1"
                                        rules={[
                                            {
                                                required: true,
                                            },
                                        ]}
                                    >
                                        <InputNumber
                                            // type="number"
                                            // value={valueRevenueExcluding}
                                            min={0}
                                            controls={false}
                                            formatter={(value) =>
                                                `${value}`.replace(
                                                    /\B(?=(\d{3})+(?!\d))/g,
                                                    ","
                                                )
                                            }
                                            // onChange={changeMoneyVND}
                                            style={{ width: "100%" }}
                                            onKeyPress={(e) => {
                                                const charCode = e.which
                                                    ? e.which
                                                    : e.keyCode;
                                                if (charCode < 48 || charCode > 57) {
                                                    e.preventDefault();
                                                }
                                                if (
                                                    charCode === 32 &&
                                                    formExpectedRevenue.getFieldValue(
                                                        e.target.id
                                                    ) !== undefined
                                                ) {
                                                    let newValue =
                                                        formExpectedRevenue.getFieldValue(
                                                            e.target.id
                                                        );
                                                    formExpectedRevenue.setFieldValue(
                                                        e.target.id,
                                                        newValue * 1000
                                                    );
                                                }
                                            }}
                                            placeholder="Nhập doanh thu dự kiến tháng 1"
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={6} offset={2}>
                                    <Form.Item
                                        name="thang_5"
                                        label=<span className="custom-field-revenue">
                                            Tháng 5
                                        </span>
                                        key="thang_5"
                                        rules={[
                                            {
                                                required: true,
                                            },
                                        ]}
                                    >
                                        <InputNumber
                                            // type="number"
                                            // value={valueRevenueExcluding}
                                            min={0}
                                            controls={false}
                                            formatter={(value) =>
                                                `${value}`.replace(
                                                    /\B(?=(\d{3})+(?!\d))/g,
                                                    ","
                                                )
                                            }
                                            // onChange={changeMoneyVND}
                                            style={{ width: "100%" }}
                                            onKeyPress={(e) => {
                                                const charCode = e.which
                                                    ? e.which
                                                    : e.keyCode;
                                                if (charCode < 48 || charCode > 57) {
                                                    e.preventDefault();
                                                }
                                                if (
                                                    charCode === 32 &&
                                                    formExpectedRevenue.getFieldValue(
                                                        e.target.id
                                                    ) !== undefined
                                                ) {
                                                    let newValue =
                                                        formExpectedRevenue.getFieldValue(
                                                            e.target.id
                                                        );
                                                    formExpectedRevenue.setFieldValue(
                                                        e.target.id,
                                                        newValue * 1000
                                                    );
                                                }
                                            }}
                                            placeholder="Nhập doanh thu dự kiến tháng 5"
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={6} offset={2}>
                                    <Form.Item
                                        name="thang_9"
                                        label=<span className="custom-field-revenue">
                                            Tháng 9
                                        </span>
                                        key="thang_9"
                                        rules={[
                                            {
                                                required: true,
                                            },
                                        ]}
                                    >
                                        <InputNumber
                                            // type="number"
                                            // value={valueRevenueExcluding}
                                            min={0}
                                            controls={false}
                                            formatter={(value) =>
                                                `${value}`.replace(
                                                    /\B(?=(\d{3})+(?!\d))/g,
                                                    ","
                                                )
                                            }
                                            // onChange={changeMoneyVND}
                                            style={{ width: "100%" }}
                                            onKeyPress={(e) => {
                                                const charCode = e.which
                                                    ? e.which
                                                    : e.keyCode;
                                                if (charCode < 48 || charCode > 57) {
                                                    e.preventDefault();
                                                }
                                                if (
                                                    charCode === 32 &&
                                                    formExpectedRevenue.getFieldValue(
                                                        e.target.id
                                                    ) !== undefined
                                                ) {
                                                    let newValue =
                                                        formExpectedRevenue.getFieldValue(
                                                            e.target.id
                                                        );
                                                    formExpectedRevenue.setFieldValue(
                                                        e.target.id,
                                                        newValue * 1000
                                                    );
                                                }
                                            }}
                                            placeholder="Nhập doanh thu dự kiến tháng 9"
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={6} offset={1}>
                                    <Form.Item
                                        name="thang_2"
                                        label=<span className="custom-field-revenue">
                                            Tháng 2
                                        </span>
                                        key="thang_2"
                                        rules={[
                                            {
                                                required: true,
                                            },
                                        ]}
                                    >
                                        <InputNumber
                                            // type="number"
                                            // value={valueRevenueExcluding}
                                            min={0}
                                            controls={false}
                                            formatter={(value) =>
                                                `${value}`.replace(
                                                    /\B(?=(\d{3})+(?!\d))/g,
                                                    ","
                                                )
                                            }
                                            // onChange={changeMoneyVND}
                                            style={{ width: "100%" }}
                                            onKeyPress={(e) => {
                                                const charCode = e.which
                                                    ? e.which
                                                    : e.keyCode;
                                                if (charCode < 48 || charCode > 57) {
                                                    e.preventDefault();
                                                }
                                                if (
                                                    charCode === 32 &&
                                                    formExpectedRevenue.getFieldValue(
                                                        e.target.id
                                                    ) !== undefined
                                                ) {
                                                    let newValue =
                                                        formExpectedRevenue.getFieldValue(
                                                            e.target.id
                                                        );
                                                    formExpectedRevenue.setFieldValue(
                                                        e.target.id,
                                                        newValue * 1000
                                                    );
                                                }
                                            }}
                                            placeholder="Nhập doanh thu dự kiến tháng 2"
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={6} offset={2}>
                                    <Form.Item
                                        name="thang_6"
                                        label=<span className="custom-field-revenue">
                                            Tháng 6
                                        </span>
                                        key="thang_6"
                                        rules={[
                                            {
                                                required: true,
                                            },
                                        ]}
                                    >
                                        <InputNumber
                                            // type="number"
                                            // value={valueRevenueExcluding}
                                            min={0}
                                            controls={false}
                                            formatter={(value) =>
                                                `${value}`.replace(
                                                    /\B(?=(\d{3})+(?!\d))/g,
                                                    ","
                                                )
                                            }
                                            // onChange={changeMoneyVND}
                                            style={{ width: "100%" }}
                                            onKeyPress={(e) => {
                                                const charCode = e.which
                                                    ? e.which
                                                    : e.keyCode;
                                                if (charCode < 48 || charCode > 57) {
                                                    e.preventDefault();
                                                }
                                                if (
                                                    charCode === 32 &&
                                                    formExpectedRevenue.getFieldValue(
                                                        e.target.id
                                                    ) !== undefined
                                                ) {
                                                    let newValue =
                                                        formExpectedRevenue.getFieldValue(
                                                            e.target.id
                                                        );
                                                    formExpectedRevenue.setFieldValue(
                                                        e.target.id,
                                                        newValue * 1000
                                                    );
                                                }
                                            }}
                                            placeholder="Nhập doanh thu dự kiến tháng 6"
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={6} offset={2}>
                                    <Form.Item
                                        name="thang_10"
                                        label=<span className="custom-field-revenue">
                                            Tháng 10
                                        </span>
                                        key="thang_10"
                                        rules={[
                                            {
                                                required: true,
                                            },
                                        ]}
                                    >
                                        <InputNumber
                                            // type="number"
                                            // value={valueRevenueExcluding}
                                            min={0}
                                            controls={false}
                                            formatter={(value) =>
                                                `${value}`.replace(
                                                    /\B(?=(\d{3})+(?!\d))/g,
                                                    ","
                                                )
                                            }
                                            // onChange={changeMoneyVND}
                                            style={{ width: "100%" }}
                                            onKeyPress={(e) => {
                                                const charCode = e.which
                                                    ? e.which
                                                    : e.keyCode;
                                                if (charCode < 48 || charCode > 57) {
                                                    e.preventDefault();
                                                }
                                                if (
                                                    charCode === 32 &&
                                                    formExpectedRevenue.getFieldValue(
                                                        e.target.id
                                                    ) !== undefined
                                                ) {
                                                    let newValue =
                                                        formExpectedRevenue.getFieldValue(
                                                            e.target.id
                                                        );
                                                    formExpectedRevenue.setFieldValue(
                                                        e.target.id,
                                                        newValue * 1000
                                                    );
                                                }
                                            }}
                                            placeholder="Nhập doanh thu dự kiến tháng 10"
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={6} offset={1}>
                                    <Form.Item
                                        name="thang_3"
                                        label=<span className="custom-field-revenue">
                                            Tháng 3
                                        </span>
                                        key="thang_3"
                                        rules={[
                                            {
                                                required: true,
                                            },
                                        ]}
                                    >
                                        <InputNumber
                                            // type="number"
                                            // value={valueRevenueExcluding}
                                            min={0}
                                            controls={false}
                                            formatter={(value) =>
                                                `${value}`.replace(
                                                    /\B(?=(\d{3})+(?!\d))/g,
                                                    ","
                                                )
                                            }
                                            // onChange={changeMoneyVND}
                                            style={{ width: "100%" }}
                                            onKeyPress={(e) => {
                                                const charCode = e.which
                                                    ? e.which
                                                    : e.keyCode;
                                                if (charCode < 48 || charCode > 57) {
                                                    e.preventDefault();
                                                }
                                                if (
                                                    charCode === 32 &&
                                                    formExpectedRevenue.getFieldValue(
                                                        e.target.id
                                                    ) !== undefined
                                                ) {
                                                    let newValue =
                                                        formExpectedRevenue.getFieldValue(
                                                            e.target.id
                                                        );
                                                    formExpectedRevenue.setFieldValue(
                                                        e.target.id,
                                                        newValue * 1000
                                                    );
                                                }
                                            }}
                                            placeholder="Nhập doanh thu dự kiến tháng 3"
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={6} offset={2}>
                                    <Form.Item
                                        name="thang_7"
                                        label=<span className="custom-field-revenue">
                                            Tháng 7
                                        </span>
                                        key="thang_7"
                                        rules={[
                                            {
                                                required: true,
                                            },
                                        ]}
                                    >
                                        <InputNumber
                                            // type="number"
                                            // value={valueRevenueExcluding}
                                            min={0}
                                            controls={false}
                                            formatter={(value) =>
                                                `${value}`.replace(
                                                    /\B(?=(\d{3})+(?!\d))/g,
                                                    ","
                                                )
                                            }
                                            // onChange={changeMoneyVND}
                                            style={{ width: "100%" }}
                                            onKeyPress={(e) => {
                                                const charCode = e.which
                                                    ? e.which
                                                    : e.keyCode;
                                                if (charCode < 48 || charCode > 57) {
                                                    e.preventDefault();
                                                }
                                                if (
                                                    charCode === 32 &&
                                                    formExpectedRevenue.getFieldValue(
                                                        e.target.id
                                                    ) !== undefined
                                                ) {
                                                    let newValue =
                                                        formExpectedRevenue.getFieldValue(
                                                            e.target.id
                                                        );
                                                    formExpectedRevenue.setFieldValue(
                                                        e.target.id,
                                                        newValue * 1000
                                                    );
                                                }
                                            }}
                                            placeholder="Nhập doanh thu dự kiến tháng 7"
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={6} offset={2}>
                                    <Form.Item
                                        name="thang_11"
                                        label=<span className="custom-field-revenue">
                                            Tháng 11
                                        </span>
                                        key="thang_11"
                                        rules={[
                                            {
                                                required: true,
                                            },
                                        ]}
                                    >
                                        <InputNumber
                                            // type="number"
                                            // value={valueRevenueExcluding}
                                            min={0}
                                            controls={false}
                                            formatter={(value) =>
                                                `${value}`.replace(
                                                    /\B(?=(\d{3})+(?!\d))/g,
                                                    ","
                                                )
                                            }
                                            // onChange={changeMoneyVND}
                                            style={{ width: "100%" }}
                                            onKeyPress={(e) => {
                                                const charCode = e.which
                                                    ? e.which
                                                    : e.keyCode;
                                                if (charCode < 48 || charCode > 57) {
                                                    e.preventDefault();
                                                }
                                                if (
                                                    charCode === 32 &&
                                                    formExpectedRevenue.getFieldValue(
                                                        e.target.id
                                                    ) !== undefined
                                                ) {
                                                    let newValue =
                                                        formExpectedRevenue.getFieldValue(
                                                            e.target.id
                                                        );
                                                    formExpectedRevenue.setFieldValue(
                                                        e.target.id,
                                                        newValue * 1000
                                                    );
                                                }
                                            }}
                                            placeholder="Nhập doanh thu dự kiến tháng 11"
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={6} offset={1}>
                                    <Form.Item
                                        name="thang_4"
                                        label=<span className="custom-field-revenue">
                                            Tháng 4
                                        </span>
                                        key="thang_4"
                                        rules={[
                                            {
                                                required: true,
                                            },
                                        ]}
                                    >
                                        <InputNumber
                                            // type="number"
                                            // value={valueRevenueExcluding}
                                            min={0}
                                            controls={false}
                                            formatter={(value) =>
                                                `${value}`.replace(
                                                    /\B(?=(\d{3})+(?!\d))/g,
                                                    ","
                                                )
                                            }
                                            // onChange={changeMoneyVND}
                                            style={{ width: "100%" }}
                                            onKeyPress={(e) => {
                                                const charCode = e.which
                                                    ? e.which
                                                    : e.keyCode;
                                                if (charCode < 48 || charCode > 57) {
                                                    e.preventDefault();
                                                }
                                                if (
                                                    charCode === 32 &&
                                                    formExpectedRevenue.getFieldValue(
                                                        e.target.id
                                                    ) !== undefined
                                                ) {
                                                    let newValue =
                                                        formExpectedRevenue.getFieldValue(
                                                            e.target.id
                                                        );
                                                    formExpectedRevenue.setFieldValue(
                                                        e.target.id,
                                                        newValue * 1000
                                                    );
                                                }
                                            }}
                                            placeholder="Nhập doanh thu dự kiến tháng 4"
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={6} offset={2}>
                                    <Form.Item
                                        name="thang_8"
                                        label=<span className="custom-field-revenue">
                                            Tháng 8
                                        </span>
                                        key="thang_8"
                                        rules={[
                                            {
                                                required: true,
                                            },
                                        ]}
                                    >
                                        <InputNumber
                                            // type="number"
                                            // value={valueRevenueExcluding}
                                            min={0}
                                            controls={false}
                                            formatter={(value) =>
                                                `${value}`.replace(
                                                    /\B(?=(\d{3})+(?!\d))/g,
                                                    ","
                                                )
                                            }
                                            // onChange={changeMoneyVND}
                                            style={{ width: "100%" }}
                                            onKeyPress={(e) => {
                                                const charCode = e.which
                                                    ? e.which
                                                    : e.keyCode;
                                                if (charCode < 48 || charCode > 57) {
                                                    e.preventDefault();
                                                }
                                                if (
                                                    charCode === 32 &&
                                                    formExpectedRevenue.getFieldValue(
                                                        e.target.id
                                                    ) !== undefined
                                                ) {
                                                    let newValue =
                                                        formExpectedRevenue.getFieldValue(
                                                            e.target.id
                                                        );
                                                    formExpectedRevenue.setFieldValue(
                                                        e.target.id,
                                                        newValue * 1000
                                                    );
                                                }
                                            }}
                                            placeholder="Nhập doanh thu dự kiến tháng 8"
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={6} offset={2}>
                                    <Form.Item
                                        name="thang_12"
                                        label=<span className="custom-field-revenue">
                                            Tháng 12
                                        </span>
                                        key="thang_12"
                                        rules={[
                                            {
                                                required: true,
                                            },
                                        ]}
                                    >
                                        <InputNumber
                                            // type="number"
                                            // value={valueRevenueExcluding}
                                            min={0}
                                            controls={false}
                                            formatter={(value) =>
                                                `${value}`.replace(
                                                    /\B(?=(\d{3})+(?!\d))/g,
                                                    ","
                                                )
                                            }
                                            // onChange={changeMoneyVND}
                                            style={{ width: "100%" }}
                                            onKeyPress={(e) => {
                                                const charCode = e.which
                                                    ? e.which
                                                    : e.keyCode;
                                                if (charCode < 48 || charCode > 57) {
                                                    e.preventDefault();
                                                }
                                                if (
                                                    charCode === 32 &&
                                                    formExpectedRevenue.getFieldValue(
                                                        e.target.id
                                                    ) !== undefined
                                                ) {
                                                    let newValue =
                                                        formExpectedRevenue.getFieldValue(
                                                            e.target.id
                                                        );
                                                    formExpectedRevenue.setFieldValue(
                                                        e.target.id,
                                                        newValue * 1000
                                                    );
                                                }
                                            }}
                                            placeholder="Nhập doanh thu dự kiến tháng 12"
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row className="row-btnSubmit-revenue">
                                <Button
                                    htmlType="submit"
                                    loading={loadingBtnDtdk}
                                    className="btn-submit-dtdk"
                                    style={{ height: "46px", width: 180 }}
                                >
                                    SUBMIT
                                </Button>
                                <Button
                                    className="btn-cancel-dtdk"
                                    onClick={closeCreateRevenue}
                                    style={{
                                        marginLeft: "30px",
                                        height: "46px",
                                        width: 180,
                                    }}
                                >
                                    CANCEL
                                </Button>
                            </Row>
                        </div>
                    </Form>
                </div>
            </div>
        </>
    )
}

export default FormCreateRevenueResponsive